/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { getJsonExport, Locale } from '@typescript-kit/core';

import * as texts from '../text/time-recording-de.text.json';
import * as formats from '../format/time-recording-de.format.json';

export const timeRecordingDeLocale: Locale = {
  texts: getJsonExport(texts),
  formats: getJsonExport(formats)
};
